export class CommunicationToken {
    token = '';

    deserialize(data: any) {
        this.token = data.decoded_token ?? '';
        return this;
    }
}
